<template>
  <div v-if="slides.length > 0" class="merch-slider-wrap">
    <div ref="merchSlider" class="merch-slider">
      <div v-if="platformSession.gameId === patch8GameId" :key="0" class="merch-slide">
        <div data-v-62a2f363="" class="blur"></div><div data-v-62a2f363="" class="merch-wrap"><div data-v-62a2f363="" class="animation-container"><span data-v-62a2f363="" class="-decor">Patch 8 Stress Test</span></div><div data-v-62a2f363="" class="animation-container"><h2 data-v-62a2f363="" class="merch-slide__title"> SHARE YOUR EXPERIENCE </h2></div><div data-v-62a2f363="" class="animation-container"><div data-v-62a2f363="" class="merch-slide__description" style="width: 60%"> Click the button below and let us know how you got on with the Patch 8 stress test! If you’re looking to report a bug, please <a href="https://larian.com/support/baldur-s-gate-3#modal" target="_blank" class="link">click here.</a> </div></div><div data-v-62a2f363="" class="animation-container animation-button"><a data-v-62a2f363="" href="https://larian.com/stress-test-feedback" target="_blank" rel="noopener noreferrer" id="pad-merch-button-1" pad-a="click" pad-down="go:#pad-merch-1" pad-up="go:#pad-news-1" pad-right="merch:next" pad-left="merch:prev" class="btn">FILL OUT THE FORM </a></div></div><div data-v-62a2f363="" class="merch-slide__banner" :style="{backgroundImage: `url(${require('@/assets/img/png/banner.png')})`}"></div>
      </div>
      <div
        v-for="(slide, index) in slides"
        :key="slide.id"
        class="merch-slide"
        id="pad-merch-widget"
        pad-up="go:#pad-news-1,#pad-banner"
        pad-left="go:#pad-get-game,#pad-play"
        pad-a="click"
      >
        <div class="blur"></div>
        <div class="merch-wrap">
          <div class="animation-container">
            <span class="-decor">{{ slide.label }}</span>
          </div>
          <div class="animation-container">
            <h2 class="merch-slide__title">
              {{ slide.title }}
            </h2>
          </div>
          <div v-if="slide.content" class="animation-container">
            <div class="merch-slide__description">
              {{ slide.content | truncate(100) }}
            </div>
          </div>
          <div class="animation-container animation-button">
            <router-link
              v-if="slide.internal"
              :to="{ path: '/merch' }"
              :id="`pad-merch-button-${index + 1}`"
              class="btn"
              pad-a="click"
              :pad-down="`go:#pad-merch-${index + 1}`"
              pad-up="go:#pad-news-1"
              pad-right="merch:next"
              pad-left="merch:prev"
              >{{ slide.buttonLabel }}
            </router-link>
            <a
              v-else
              :href="slide.buttonLink"
              target="_blank"
              rel="noopener noreferrer"
              :id="`pad-merch-button-${index + 1}`"
              class="btn"
              pad-a="click"
              :pad-down="`go:#pad-merch-${index + 1}`"
              pad-up="go:#pad-news-1"
              pad-right="merch:next"
              pad-left="merch:prev"
              >{{ slide.buttonLabel }}
            </a>
          </div>
        </div>
        <div
          class="merch-slide__banner"
          :style="{
            backgroundImage: `url(${getImage(slide.image)})`
          }"
        ></div>
      </div>
    </div>
    <ol class="flickity-page-dots">
      <li
        v-for="(item, index) in slides"
        :key="index"
        class="dot"
        :class="{ 'is-selected': activeSlide === index + 1 }"
        :id="`pad-merch-${index + 1}`"
        :pad-right="`go:#pad-merch-${index + 2}`"
        :pad-left="
          index + 1 === 1
            ? `go:#pad-play,#pad-get-game`
            : `go:#pad-merch-${index}`
        "
        :pad-up="`go:#pad-merch-button-${activeSlide}`"
        pad-a="click"
        tabindex="1"
        @click="changeSlide(index + 1)"
      ></li>
      <li
        v-if="platformSession.gameId === patch8GameId"
        :key="slides.length + 1"
        class="dot"
        :class="{ 'is-selected': activeSlide === slides.length + 1 }"
        :id="`pad-merch-${slides.length + 1}`"
        :pad-right="`go:#pad-merch-1`"
        :pad-left="`go:#pad-merch-${slides.length + 1}`"
        :pad-up="`go:#pad-merch-button-${activeSlide}`"
        pad-a="click"
        tabindex="1"
        @click="changeSlide(slides.length + 1)"
      ></li>
    </ol>
  </div>
</template>

<script>
import axios from "axios";
import Flickity from "flickity";
import {mapState} from "vuex";

let flkty;

export default {
  props: {
    cacheVersion: {
      type: String
    }
  },
  data() {
    return {
      patch8GameId: "2912110",
      sliderOptions: {
        prevNextButtons: false,
        wrapAround: true,
        align: "left",
        pageDots: false,
        resize: true,
        setGallerySize: false,
        autoPlay: 6000,
        pauseAutoPlayOnHover: true,
        on: {
          ready: () => {
            this.isSlideVisible = true;
          }
        }
      },
      isSlideVisible: false,
      slides: [],
      activeSlide: 1
    };
  },

  computed: {
    ...mapState({
      platformSession: state => state.platformSession,
    })
  },

  methods: {
    initSlider() {
      flkty = new Flickity(this.$refs.merchSlider, this.sliderOptions);
      document.merchSlider = flkty;

      flkty.on("change", () => {
        this.activeSlide = flkty.selectedIndex + 1;
      });

      document.merchSlider.on("change", function(index) {
        if (this.isPad) {
          document.pad.focus(`#pad-merch-button-${index + 1}`);
          this.isPad = false;
        }
      });
    },

    changeSlide(index) {
      this.activeSlide = index;
      flkty.select(this.activeSlide - 1);
    },

    fetchSlider() {
      const version = this.cacheVersion;
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/cache/launcher-merch-slider.json${version}`,
          { withCredentials: false }
        )
        .then(res => {
          this.slides = res.data;
          setTimeout(() => {
            this.initSlider();
          }, 100);
        });
    },

    getImage(image) {
      return image && image.url
        ? process.env.VUE_APP_API_HOST + image.url
        : require("@/assets/img/png/merch-banner.png");
    }
  },

  created() {},

  mounted() {
    this.fetchSlider();
  }
};
</script>

<style lang="scss" scoped>
.merch-slider-wrap {
  margin-bottom: 4vh;

  .flickity-page-dots {
    bottom: -15px;
  }
}

.merch-slider {
  height: 29vh;
  width: 35vw;
}
.merch-slide {
  display: inline-block;
  margin-top: auto;
  padding: 3vh 3vw;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: $black;
    opacity: 0.4;
    z-index: -1;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 1px;
    background: $yellow;
    transition: width 0.3s ease;
  }

  .blur {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(12px);
    z-index: -1;
  }

  .merch-wrap {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
    z-index: 1;
  }

  .-decor {
    font-size: 10px;
    margin-bottom: 10px;
    transform: translateY(calc(100% + 10px));
    animation: slide-in 500ms forwards;
    animation-delay: 2100ms;
  }

  &__title {
    color: $white;
    font-size: 18px;
    margin-bottom: 10px;
    width: 70%;
    transform: translateY(200%);
    animation: slide-in 500ms forwards;
    animation-delay: 2200ms;
  }

  &__description {
    color: $white-70;
    font-size: 14px;
    margin-bottom: 10px;
    width: 70%;
    line-height: 1.2;
    transform: translateY(200%);
    animation: slide-in 500ms forwards;
    animation-delay: 2300ms;
  }

  p {
    color: $white-70;
    width: 60%;
    display: none;
  }

  .animation-button {
    margin-top: auto;
  }

  .btn {
    margin-top: auto;
    align-self: flex-start;
    transform: translateX(-100%);
    animation: slide-in-button 500ms forwards;
    animation-delay: 2500ms;
  }

  .button-wrap {
    margin-top: auto;
  }

  &__banner {
    width: 70%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background-size: cover;
    background-position: 100% 35%;
    z-index: 0;
    transition: transform 0.3s ease;
  }

  &:hover {
    &::after {
      width: 100%;
    }

    .merch-slide__banner {
      transform: translateX(20px);
    }
  }
}

@media screen and (max-height: 650px) {
  .merch-slide {
    &__description {
      display: none;
    }
  }
}

@media screen and (min-width: $screen-medium) {
  .merch-slide {
    .-decor {
      font-size: 12px;
    }

    &__title {
      font-size: 22px;
    }

    &__description {
      display: block;
    }

    p {
      display: block;
    }

    &:hover {
      .btn {
        &::after {
          width: 75px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
@keyframes slide-in {
  100% {
    transform: translateY(0);
  }
}

@keyframes slide-in-button {
  100% {
    transform: translateX(0);
  }
}
</style>
